'use client';

import { cosmicFactory, PlatformCosmicModule } from '@finn/ui-cosmic';
import { CookieKeys } from '@finn/ui-utils';
import Cookies from 'js-cookie';
import { useMemo } from 'react';

import { getPlatformFeatures } from '../features';

type PlatformComponentProps = {
  module: PlatformCosmicModule;
  features?: ReturnType<typeof getPlatformFeatures>;
};

export const PlatformComponent = ({
  module,
  features,
}: PlatformComponentProps) => {
  const CosmicModule = useMemo(
    () =>
      cosmicFactory({
        ...getPlatformFeatures(),
        ...features,
      }).make(),
    [features]
  );

  // if module marked as devonly, we show it only
  // when cosmic helper enabled
  if (module?.devonly || module?.metadata?.devonly) {
    const isDevMode =
      Cookies.get(CookieKeys.DEV_PASS) ===
      Cookies.get(CookieKeys.COSMIC_HELPER);
    if (!isDevMode) {
      return null;
    }
  }

  if (module === null) {
    return null;
  }

  // metadata.modules is only present when the current module is a group that simply bundles other sub-modules together
  if (!module?.metadata?.modules) {
    return <CosmicModule PlatformComponent={PlatformComponent} data={module} />;
  }

  // If a modules array is present, the current module is a container. We then recurse over its children and lay them out in a grid
  return (
    <div
      className="grid w-full"
      style={{ gridRowGap: module?.metadata?.gap_between_modules }}
    >
      {module.metadata.modules.map((moduleItem) => (
        <PlatformComponent
          features={features}
          key={moduleItem.id}
          module={moduleItem}
        />
      ))}
    </div>
  );
};
